import moment from 'moment-mini'

import { Injectable } from '@angular/core'

import { Report } from './report'

@Injectable()
export class ReportSerializer {
  fromJson(json: any): Report {
    const report = {
      ...json
    }

    return report
  }

  toJson(report: Report): any {
    return {
      ...report
    }
  }
}
